module.exports = __webpack_public_path__ + "img/chat-sidebar@3x.ef2d36bf.png";